import type { IconData } from '@stacksjs/iconify-core'

export const virtualReality: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M40.56 40.086c2.148-.312 3.678-2.009 3.906-4.168C44.726 33.442 45 29.72 45 25s-.273-8.442-.534-10.917c-.228-2.16-1.758-3.857-3.907-4.169C37.565 9.48 32.364 9 24 9s-13.565.48-16.56.914c-2.148.312-3.678 2.009-3.906 4.169C3.274 16.558 3 20.279 3 25s.273 8.442.534 10.918c.228 2.16 1.758 3.856 3.907 4.168c1.632.237 3.919.487 7.016.666a3.94 3.94 0 0 0 2.683-.864l3.764-3.012a4 4 0 0 1 2.5-.876h1.193a4 4 0 0 1 2.499.876l3.764 3.012c.759.607 1.713.92 2.683.864c3.097-.18 5.384-.43 7.016-.666\"/><path d=\"M9 24a6 6 0 1 0 12 0a6 6 0 1 0-12 0m18 0a6 6 0 1 0 12 0a6 6 0 1 0-12 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default virtualReality
